import { useEffect } from "react";

/**
 * useSEO — Dynamiska <title>, <meta description> och JSON-LD per sida.
 *
 * @param {object} options
 * @param {string} options.title - Sidans titel
 * @param {string} options.description - Meta description
 * @param {object} [options.schema] - JSON-LD strukturerad data (Schema.org)
 */
export function useSEO({ title, description, schema }) {
  useEffect(() => {
    // Title
    if (title) {
      document.title = title;
    }

    // Meta description
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.name = "description";
        document.head.appendChild(meta);
      }
      meta.content = description;

      // OG tags
      let ogDesc = document.querySelector('meta[property="og:description"]');
      if (ogDesc) ogDesc.content = description;

      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle && title) ogTitle.content = title;
    }

    // JSON-LD Schema.org
    let scriptEl = document.getElementById("seo-jsonld");
    if (schema) {
      if (!scriptEl) {
        scriptEl = document.createElement("script");
        scriptEl.id = "seo-jsonld";
        scriptEl.type = "application/ld+json";
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(schema);
    }

    return () => {
      // Cleanup JSON-LD on unmount
      const el = document.getElementById("seo-jsonld");
      if (el) el.remove();
    };
  }, [title, description, schema]);
}
